module.exports = __webpack_public_path__ + "static/media/lunalogistik-office-geneva-switzerland.c77047d5.png";